export enum QueryPeriods {
  day = 'day',
  week = 'week',
  month = 'month',
}
